import { Outlet } from 'react-router-dom';
import { Topbar } from './Topbar';
import { Sidebar } from './Sidebar';

/**
 * Authenticated shell — Topbar across the top, Sidebar on the left,
 * page content fills the rest. Child routes render in <Outlet>.
 */
export function AppLayout() {
  return (
    <div className="flex h-screen flex-col bg-brand-off-white">
      <Topbar />
      <div className="flex flex-1 overflow-hidden">
        <Sidebar />
        <main className="flex-1 overflow-y-auto p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
